import React from "react";

const SpreadingLoveSection = () => {
  return (
    <div className="flex justify-between  mx-[2%] sm:mx-[5%] pt-[2.4rem] items-center font-Wonderbar">
      <p
        className={
          "text-[#D31C4F] relative text-[2.3rem] lg:text-[4rem] "
        }
      >
        Spreading{" "}
        <span className={"text-black"}>Love</span> Since
        30<span className="font-Lato font-bold">+</span>Years
        <img
          className="absolute h-[35px] sm:h-[60px] sm:w-[60px] sm:right-[-10%] sm:top-[-10px] top-[-10%] right-[0%] "
          src="bird.gif"
          alt=""
        />
      </p>
    </div>
  );
};

export default SpreadingLoveSection;
